import * as React from "react";

import Loading from "common/fragments/Loading";
import { ButtonView } from "common/views/button/Button.view";
import { RowsView } from "common/views/rows/Rows.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import CategoriesPanelConfig from "./config/CategoriesPanelConfig";
import Category from "./entity/Category";

const CategoriesQuery = Query.queryMany<Category, any>(Category);

@Panel({id: "forumCategories", configClass: CategoriesPanelConfig, pageParams: true})
class CategoriesPanel extends React.Component<IPanelProps<CategoriesPanelConfig>> {

	public render() {
		const { config, pageParams, actions } = this.props;

		return (
			<CategoriesQuery params={{forumIds: [config.forum]}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if(!data) {
							return "No Categories";
						}

						// push the params seperatly from the link to allow use on the same page as the forum panel
						return (
							<RowsView viewKey="category.list">
								{data.map((category) => (
									<ButtonView
										viewKey="category.link.view"
										isActive={pageParams && pageParams.categoryId === category.id.toString()}
										onClick={() => actions.pushPagePath(config.path, {
											categoryId: category.id.toString(),
											categoryName: category.name
										})}
									>
										{category.name}
									</ButtonView>
								))}
							</RowsView>
						);
					}
				}
			</CategoriesQuery>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/forum/Categories.panel.tsx